import React, { useState, useEffect, useRef } from 'react';

interface ShortVideoPlayerProps {
  videoId: string;
  title: string;
  isActive: boolean;
  thumbnail: string; // 👈 NOVA PROPRIEDADE AQUI
  category?: string; // 👈 ADICIONA ISTO AQUI
}

export default function ShortVideoPlayer({ videoId, title, isActive, thumbnail,category }: ShortVideoPlayerProps) { // 👈 ADICIONE O thumbnail AQUI TAMBÉM
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0); // 0 a 100%
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showControls, setShowControls] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const playerRef = useRef<any>(null);
  const intervalRef = useRef<any>(null);
  const hideTimeoutRef = useRef<any>(null);

  const [hasStarted, setHasStarted] = useState(false); // 👈 Controla a cortina

  const hasRegisteredInterest = useRef(false); // 👈 Controla para não registar o mesmo vídeo várias vezes

  // Carrega a API do YouTube Iframe se ainda não existir
  useEffect(() => {
    if (!(window as any).YT) {
      const tag = document.createElement('script');
      tag.src = 'https://www.youtube.com/iframe_api';
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    }
  }, []);

 // Inicializa ou destrói o player do YouTube quando o vídeo fica ativo
  useEffect(() => {
    if (!isActive) {
      if (playerRef.current && typeof playerRef.current.destroy === 'function') {
        playerRef.current.destroy();
        playerRef.current = null;
      }
      setIsPlaying(false);
      setHasStarted(false); // 👈 FECHA A CORTINA QUANDO SAI DA TELA
      clearInterval(intervalRef.current);
      return;
    }
const initPlayer = () => {
      if ((window as any).YT && (window as any).YT.Player) {
        if (playerRef.current) return;

        playerRef.current = new (window as any).YT.Player(`yt-player-${videoId}`, {
          videoId: videoId,
          playerVars: {
            autoplay: 1,
            controls: 0,
            disablekb: 1,
            fs: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            rel: 0,
            // 🛡️ TRUQUE 1: Declaramos as legendas como 0 e forçamos um idioma inexistente/nulo
            cc_load_policy: 0, 
            hl: 'en', // Enganamos o YouTube
            cc_lang_pref: 'en'
          },
          events: {
            onReady: (event: any) => {
              // 🛡️ TRUQUE 2: A Solução Nuclear
              try {
                event.target.unloadModule('captions');
                event.target.unloadModule('cc');
              } catch (e) {}

              // Não abre a cortina aqui ainda! Apenas manda dar o play.
              event.target.playVideo();
              setDuration(event.target.getDuration());
            },
            onStateChange: (event: any) => {
              // 🛡️ TRUQUE 3: Se o vídeo começar a tocar e a legenda insistir, nós removemos à força
              if (event.data === (window as any).YT.PlayerState.PLAYING) {
                  try {
                      // Este comando é específico do iFrame para desligar as legendas se elas estiverem ativas
                      event.target.unloadModule('captions'); 
                  } catch (e) {}

                setHasStarted(true); // 👈 AGORA SIM! O VÍDEO ESTÁ RODANDO! ABRE A CORTINA!
                setIsPlaying(true);
                startTracking();
              } else if (event.data === (window as any).YT.PlayerState.PAUSED) {
                setIsPlaying(false);
                clearInterval(intervalRef.current);
              } else if (event.data === (window as any).YT.PlayerState.ENDED) {
                // Loop automático do short
                event.target.seekTo(0);
                event.target.playVideo();
              }
            }
          }
        });
      }
    };
    if ((window as any).YT && (window as any).YT.Player) {
      initPlayer();
    } else {
      (window as any).onYouTubeIframeAPIReady = initPlayer;
      const checkInterval = setInterval(() => {
        if ((window as any).YT && (window as any).YT.Player) {
          clearInterval(checkInterval);
          initPlayer();
        }
      }, 100);
    }

    return () => {
      clearInterval(intervalRef.current);
      if (playerRef.current && typeof playerRef.current.destroy === 'function') {
        playerRef.current.destroy();
        playerRef.current = null;
      }
    };
  }, [isActive, videoId]);

  // Monitora o tempo atual do vídeo para atualizar a barra
  const startTracking = () => {
    clearInterval(intervalRef.current);
    intervalRef.current = setInterval(() => {
      if (playerRef.current && typeof playerRef.current.getCurrentTime === 'function') {
        const current = playerRef.current.getCurrentTime() || 0;
        const total = playerRef.current.getDuration() || 1;
        setCurrentTime(current);
        setDuration(total);
        if (!isDragging) {
          setProgress((current / total) * 100);
        }
      }
    }, 200);
  };

  // Lógica de clique para pausar/reproduzir e mostrar os controles
  const handleContainerClick = () => {
    if (!playerRef.current || typeof playerRef.current.getPlayerState !== 'function') return;
    
    const state = playerRef.current.getPlayerState();
    if (state === (window as any).YT.PlayerState.PLAYING) {
      playerRef.current.pauseVideo();
    } else {
      playerRef.current.playVideo();
    }

    // Mostra os controles e esconde sozinho após 3 segundos sem toque
    setShowControls(true);
    clearTimeout(hideTimeoutRef.current);
    hideTimeoutRef.current = setTimeout(() => {
      setShowControls(false);
    }, 3000);
  };

  // Quando o usuário arrasta ou clica na barra de progresso
  const handleProgressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPercent = parseFloat(e.target.value);
    setProgress(newPercent);
    if (playerRef.current && typeof playerRef.current.seekTo === 'function') {
      const newTime = (newPercent / 100) * duration;
      playerRef.current.seekTo(newTime, true);
      setCurrentTime(newTime);
    }
  };

  const handleTouchStart = () => {
    setIsDragging(true);
  };

  const handleTouchEnd = () => {
    setIsDragging(false);
  };

  // 🧠 O OLHEIRO: Deteta se o utilizador realmente gostou do vídeo
  useEffect(() => {
    // Só funciona se o vídeo estiver ativo, se ainda não tivermos registado e se existir uma categoria
    if (isActive && !hasRegisteredInterest.current && category && category !== 'shorts') { // Ignoramos a categoria genérica 'shorts'
      
      // REGRA DE OURO: Assistiu a mais de 10 segundos OU viu mais de 60% do vídeo? Então ele gostou!
      if (currentTime > 10 || progress > 60) {
        hasRegisteredInterest.current = true; // Marca como registado para não repetir

        try {
          // 1. Puxa a memória secreta do telemóvel
          const savedPrefs = localStorage.getItem('doisplay_user_prefs');
          let prefsArray = savedPrefs ? JSON.parse(savedPrefs) : [];

          // 2. Adiciona esta categoria à lista de gostos
          prefsArray.push(category);

          // 3. Mantém apenas as últimas 15 categorias (para o algoritmo focar no que ele gosta AGORA)
          if (prefsArray.length > 15) {
            prefsArray.shift(); // Remove a mais antiga
          }

          // 4. Guarda de volta no telemóvel
          localStorage.setItem('doisplay_user_prefs', JSON.stringify(prefsArray));
          
          // Apenas para tu veres a funcionar no painel de programador (podes apagar depois)
          console.log('🤖 Algoritmo aprendeu! Utilizador gosta de:', category);
        } catch (e) {
          console.error('Erro ao salvar preferência:', e);
        }
      }
    }
  }, [currentTime, progress, isActive, category]);

  // Reseta o Olheiro quando o vídeo sai da tela
  useEffect(() => {
    if (!isActive) {
      hasRegisteredInterest.current = false;
    }
  }, [isActive, videoId]);
return (
    <div 
      onClick={handleContainerClick}
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        backgroundColor: '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        cursor: 'pointer'
      }}
    >
      {/* Container Onde o YouTube é Renderizado com Zoom proporcional para tela vertical */}
      <div 
        id={`yt-player-${videoId}`} 
        style={{ 
          width: '100%', 
          height: '100%', 
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
          overflow: 'hidden'
        }} 
      />

      {/* 🎭 CORTINA MÁGICA: Fica por cima até o YouTube dar o primeiro PLAY */}
      {!hasStarted && (
        <img 
          src={thumbnail} 
          alt="Carregando..." 
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: 4, 
            filter: 'brightness(0.8)',
            transition: 'opacity 0.4s ease' // Faz ela sumir de forma suave, sem piscar sec
            
          }}
        />
      )}
      

      
    </div>
  );
}